import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { SyncProvider } from "@/context/SyncContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Promo from "@/pages/Promo";
import Assistente from "@/pages/Assistente";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Acquisti from "@/pages/Acquisti";
import Coperti from "@/pages/Coperti";
import Charter from "@/pages/Charter";
import MenuPage from "@/pages/Menu";
import Fornitori from "@/pages/Fornitori";
import PriceCompare from "@/pages/PriceCompare";
import Ricette from "@/pages/Ricette";
import Ordini from "@/pages/Ordini";
import Scan from "@/pages/Scan";
import Giacenze from "@/pages/Giacenze";
import Scadenze from "@/pages/Scadenze";
import Marpol from "@/pages/Marpol";
import Report from "@/pages/Report";
import Setup from "@/pages/Setup";
import Utenti from "@/pages/Utenti";
import Clienti from "@/pages/Clienti";
import Contatti from "@/pages/Contatti";
import Ospiti from "@/pages/Ospiti";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function LoadingScreen() {
  return (
    <div className="flex h-screen items-center justify-center bg-navy">
      <img src="/logo.png" alt="logo" className="h-20 w-20 animate-pulse rounded-xl" />
    </div>
  );
}

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return (
    <ConfigProvider>
      <SyncProvider>
        <Layout>{children}</Layout>
      </SyncProvider>
    </ConfigProvider>
  );
}

function RootRoute() {
  const { user, ready } = useAuth();
  if (!ready) return <LoadingScreen />;
  if (!user) return <Landing />;
  return (
    <ConfigProvider>
      <SyncProvider>
        <Layout><Dashboard /></Layout>
      </SyncProvider>
    </ConfigProvider>
  );
}

function AppRoutes() {
  const location = useLocation();
  // Process the Google OAuth callback synchronously during render (before ProtectedRoute).
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/promo" element={<Promo />} />
      <Route path="/assistente" element={<Assistente />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/" element={<RootRoute />} />
      <Route path="/acquisti" element={<Protected><Acquisti /></Protected>} />
      <Route path="/coperti" element={<Protected><Coperti /></Protected>} />
      <Route path="/charter" element={<Protected><Charter /></Protected>} />
      <Route path="/menu" element={<Protected><MenuPage /></Protected>} />
      <Route path="/fornitori" element={<Protected><Fornitori /></Protected>} />
      <Route path="/prezzi" element={<Protected><PriceCompare /></Protected>} />
      <Route path="/ricette" element={<Protected><Ricette /></Protected>} />
      <Route path="/ordini" element={<Protected><Ordini /></Protected>} />
      <Route path="/scan" element={<Protected><Scan /></Protected>} />
      <Route path="/giacenze" element={<Protected><Giacenze /></Protected>} />
      <Route path="/scadenze" element={<Protected><Scadenze /></Protected>} />
      <Route path="/marpol" element={<Protected><Marpol /></Protected>} />
      <Route path="/report" element={<Protected><Report /></Protected>} />
      <Route path="/setup" element={<Protected><Setup /></Protected>} />
      <Route path="/utenti" element={<Protected><Utenti /></Protected>} />
      <Route path="/clienti" element={<Protected><Clienti /></Protected>} />
      <Route path="/contatti" element={<Protected><Contatti /></Protected>} />
      <Route path="/ospiti" element={<Protected><Ospiti /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
